import {makeAutoObservable} from "mobx";

export default class CommentStore {
    comments = []
    constructor() {
        makeAutoObservable(this)
    }

    setComments(comments) {
        this.comments = comments
    }

}